const AddIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="19"
        fill="none"
        {...props}
    >
        <path d="M8 2.573V.783c0-.45-.54-.67-.85-.35l-2.8 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.32.31.86.09.86-.36v-1.79c3.31 0 6 2.69 6 6 0 2.72-1.83 5.02-4.31 5.75-.42.12-.69.52-.69.95 0 .65.62 1.16 1.25.97a7.991 7.991 0 0 0 5.75-7.67c0-4.42-3.58-8-8-8ZM2 10.573c0-1.34.44-2.58 1.19-3.59.3-.4.26-.95-.09-1.31-.42-.42-1.14-.38-1.5.1a7.991 7.991 0 0 0 4.15 12.47c.63.19 1.25-.32 1.25-.97 0-.43-.27-.83-.69-.95-2.48-.73-4.31-3.03-4.31-5.75Z" />
    </svg>
);

export default AddIcon;
